<template>
    <div>
        <banner-generic :data="data.hero"></banner-generic>
        
        <section class="padding--lg relative section--form">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <div>
                            <!-- <p>Sunt autem nusquam hoc epicurus in gravissimo bello animadversionis metu contineret, saluti prospexit. simo bello animadversionis metu continere sunt autem nusquam hoc epicurus in gravis.</p> -->
                            
                            <div class="form-success hide">
                                <h4>Thank you for your submission</h4>
                            </div>

                            <div class="form-failed hide">
                                <h4>Unfortunately we weren’t able to submit your request. Please contact our team directly on via our <a href="/contact">contact form</a> and we can organise your sample for you directly.</h4>
                            </div>

                            <div class="form--loading hide">
                                <div class="form--loading-spinner padding--xl">
                                    <div class="loader"></div>
                                    <span>SUBMITTING</span>
                                </div>
                            </div>
                            
                            <sample-form
                                :personas="data.personas"
                                :colours="data.colourModal"
                                :selectedColours="convertItemsObjToArray(data.selectedColours)"
                                :brochures="data.brochureModal"
                                :selectedBrochures="convertItemsObjToArray(data.selectedBrochures)"
                                :solutions="data.solutionModal"
                                :selectedSolutions="convertItemsObjToArray(data.selectedSolutions)"
                                :CompleteRedirectURL="data.CompleteRedirectURL"
                            />

                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    import { BannerGeneric, SampleForm, Cta } from "../components";

    export default {
        name: "v-sample",
        components: {
            BannerGeneric,
            SampleForm,
            Cta,
        },
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {
                selectedColours: [],
                selectedBrochures: [],
                selectedSolutions: [],
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../scss/abstracts/variables";

    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loader {
        border: 5px solid #f3f3f3;
        border-radius: 50%;
        border-top: 5px solid #2d2c2c;
        border-bottom: 5px solid #2d2c2c;
        border-right: 5px solid #2d2c2c;
        width: 40px;
        height: 40px;
        -webkit-animation: spin 1s linear infinite;
        animation: spin 1s linear infinite;
    }

    .relative {
        position: relative;
    }

    .form--loading {
        // position: absolute;
        height: 400px;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        z-index: 10;
        background: rgba(255, 255, 255, 0.7);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
    }

    .form--loading-spinner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .form--loading-spinner span {
        padding-top: 10px;
    }


    h4 {
        a {
            text-decoration: underline;
        }
    }

    .form-success,
    .form-failed,
    .form--loading {
        &.hide {
            visibility: hidden;
            opacity: 0;
            transition: visibility 0s 2s, opacity 2s linear;
            display: none;
        }

        &.show {
            visibility: visible;
            opacity: 1;
            transition: visibility 0s 2s, opacity 2s linear;
            display: block;
        }
    }

    .section--form {
        &.is--loading {

        }
    }

</style>


